import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home/index.vue'
import Index from "../views/Index/index.vue"

Vue.use(VueRouter)


const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve && onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
  // return originalPush.call(this, location,()=>{},()=>{})
}

const originalReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function replace(location, onResolve, onReject) {
  if (onResolve || onReject) return originalReplace.call(this, location, onResolve, onReject)
  return originalReplace.call(this, location).catch(err => err)
}


  const routes = [
  {
    path: '/',
    name: 'Index',
    component: Index,
    meta:{
      title:"首页",
      keepAlive:false
    }
  },
  {
    path: '/home',
    name: 'Home',
    component: Home,
    meta:{
      title:"首页",
      keepAlive:false
    }
  },
  {
    path:"/moreScience",
    name:"moreScience",
    component:()=> import("../views/moreScience/index.vue"),
    meta:{
      title:"更多景区",
      keepAlive:false
    }
  },
  {
    path:"/coordinate",
    name:"coordinate",
    component:()=> import("../views/Coordinate/index.vue"),
    meta:{
      title:"定位采点",
      keepAlive:false
    }
  },
  {
    path:"/Write",
    name:"Write",
    component:()=> import("../views/Write/index.vue"),
    meta:{
      title:"核销",
      keepAlive:false
    }
  },
    {
      path: "/order",
      name: "order",
      component: () => import("../views/Order/index.vue"),
      meta: {
        title: "预定",
        keepAlive: false
      }
    }, 
  // {
  //   path: '/about',
  //   name: 'About',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  // }
]

const router = new VueRouter({
  mode: 'hash',  //hash  可以用户直接输入地址定位到
  // mode: 'history',  //hash  可以用户直接输入地址定位到
  base: process.env.BASE_URL,
  routes,

  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
})
router.beforeEach((to,from,next)=>{
  // window.document.title = to.meta.title == undefined ? baseTitle : to.meta.title + "-" + baseTitle 
  next()
})

export default router
